import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { DesignationLevel } from "../models/designationlevel"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class DesignationLevelService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'designationlevel/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllDesignationLevel(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<DesignationLevel>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllDesignationLevel?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
 
  viewDesignationLevel(DesignationLevelID?: number): Observable<Array<DesignationLevel>> {
    return this.httpService.get(this.apiEndpoint + 'viewDesignationLevel/' + (DesignationLevelID ? DesignationLevelID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveDesignationLevel(designationlevels: DesignationLevel): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveDesignationLevel/', designationlevels).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  } 

  deleteDesignationLevel(DesignationLevelID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteDesignationLevel/' + (DesignationLevelID ? DesignationLevelID : '00000000-0000-0000-0000-000000000000'), DesignationLevelID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(DesignationLevelName?: string,DesignationLevelId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?DesignationLevelName=' + (DesignationLevelName ? DesignationLevelName : '')+ '&DesignationLevelId=' + (DesignationLevelId ? DesignationLevelId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
